import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface ScottRunningIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function ScottRunningSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const mainFillColor = variant === "light" ? "#FAFAF9" : "#0C0A09";
  const strokeColor = variant === "light" ? "#44403C" : "#0C0A09";
  const textFillColor = variant === "light" ? "#44403C" : "#FAFAF9";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 18 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>SCOTT Running</title>
      <path
        d="M3.80437 7.25211C3.71816 7.08979 3.66719 6.90503 3.66719 6.70679C3.66719 6.50855 3.71501 6.33212 3.79745 6.17173L5.13461 3.79991C5.13461 3.79991 5.21327 3.6145 5.46938 3.43679C5.72612 3.25908 6.02816 3.26871 6.02816 3.26871L9.34623 3.26999L11.1994 0H4.57835C3.98685 0.00320776 3.46834 0.315002 3.16882 0.785901L0.703392 5.16257C0.36737 5.74189 0.173559 6.41616 0.173559 7.13727C0.173559 7.85837 0.364223 8.52238 0.694583 9.09785V9.10106L3.36515 13.7914L4.98108 10.9635C5.24725 10.4644 5.2548 9.86002 5.00184 9.35511L3.805 7.25211H3.80437Z"
        fill={mainFillColor}
      />
      <path
        d="M8.93861 9.86498C9.02419 10.0273 9.07516 10.214 9.07516 10.4109C9.07516 10.6079 9.02733 10.7856 8.9449 10.9454L7.60836 13.3185C7.60836 13.3185 7.52907 13.5032 7.27234 13.6809C7.01623 13.858 6.71356 13.849 6.71356 13.849L3.39612 13.8471L1.54359 17.1171H8.16462C8.75613 17.1139 9.27463 16.8014 9.57479 16.3312L12.0402 11.9539C12.3756 11.3746 12.5694 10.7016 12.5694 9.97918C12.5694 9.25679 12.3788 8.59471 12.0478 8.01859V8.01603L9.37783 3.32564L7.7619 6.1536C7.49572 6.65209 7.48817 7.25707 7.74114 7.76197L8.93861 9.86434V9.86498Z"
        fill={mainFillColor}
      />
      <circle
        cx="12.3217"
        cy="13.4619"
        fill={mainFillColor}
        r="5.03814"
        stroke={strokeColor}
      />
      <path
        d="M11.4185 14.1748V15.9792H10.3471V11.0593H12.6801C12.9856 11.0593 13.2487 11.1251 13.4696 11.2567C13.6904 11.3882 13.862 11.5715 13.9841 11.8065C14.1063 12.0414 14.1674 12.3163 14.1674 12.6311C14.1674 12.9601 14.0922 13.2514 13.9418 13.5052C13.7962 13.7542 13.573 13.9351 13.2722 14.0479L14.2379 15.9792H13.0467L12.1868 14.1748H11.4185ZM11.4185 13.2726H12.5462C12.6543 13.2726 12.7459 13.2538 12.8211 13.2162C12.8963 13.1786 12.955 13.1245 12.9973 13.054C13.0396 12.9789 13.0608 12.8896 13.0608 12.7862V12.4761C13.0608 12.368 13.0396 12.2787 12.9973 12.2082C12.955 12.1377 12.8963 12.0837 12.8211 12.0461C12.7459 12.0085 12.6543 11.9897 12.5462 11.9897H11.4185V13.2726Z"
        fill={textFillColor}
      />
    </svg>
  );
}

export function IconScottRunning(props: ScottRunningIconProps) {
  return (
    <IconWrapper {...props}>
      <ScottRunningSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
